import React, { useEffect, useRef } from 'react';
import HtmlToReact from 'html-to-react';
import gsap from 'gsap';
import styles from './styles.module.scss';

export const HtmlBlock = ({ content, children }) => {
  const containerRef = useRef(null);
  const Parser = new HtmlToReact.Parser();

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const elements = container.querySelectorAll('.fade-in');

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            gsap.to(entry.target, {
              opacity: 1,
              y: 0,
              duration: 1,
              delay: parseFloat(entry.target.dataset.delay || '0'),
              ease: 'power2.out',
            });
            obs.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.7,
      }
    );

    elements.forEach((el) => {
      gsap.set(el, { opacity: 0, y: 20 });
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, [content]);

  return (
    <div ref={containerRef} className={styles.html}>
      {Parser.parse(content || children)}
    </div>
  );
};
